// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JYnFF","footer":"styles_footer__2v8Qn","passCodeTooltip":"styles_passCodeTooltip__fUr-2"};